import { action } from "../common/Action"
import { GeographicClient } from "../generated";
const Client = new GeographicClient();
class ProvinceActions {

    @action
    getAll() {
        return Client.getProvince();
    };
}
export default new ProvinceActions();